import { isEmpty } from 'lodash'
import { adminStore } from 'services/state'

import { getPermissionObject } from './helpers'
import { PERMISSION_TABLE, permList } from './constant'
import {
  createPermission,
  fetchPermissions,
  removePermission
} from 'services/api/administration/scenario'

export const getPermissions = async () => {
  try {
    const { body } = await fetchPermissions()

    adminStore.update((prevState) => ({
      ...prevState,
      scenario: body
    }))
  } catch (err) {
    console.error(err)
    return []
  }
}

export const savePermission = async ({
  role,
  fields = [],
  blocks,
  columns
}) => {
  const formattedFields = fields.reduce(
    (acc, { value }) => ({ ...acc, [value]: true }),
    getPermissionObject(columns, false)
  )

  const permissions = Object.values(blocks).reduce((acc, values) => {
    const { scenarioTypes, minePermissions, otherPermissions } = values
    const permissions = []

    for (const type of scenarioTypes) {
      const userPerm = getPermissionObject(permList, !isEmpty(minePermissions))
      const otherPerm = getPermissionObject(permList, false)

      permissions.push(
        {
          ...userPerm,
          scenarioType: type.value,
          rolename: role
        },
        {
          ...otherPerm,
          read: !isEmpty(otherPermissions),
          rolename: 'others',
          scenarioType: type.value
        }
      )
    }

    return [...acc, ...permissions]
  }, [])

  const body = {
    rolename: role,
    fields: formattedFields,
    permissions
  }

  await createPermission(body)
  await getPermissions()
}

export const updatePermission = async ({ record, name, table, ...other }) => {
  const newRecord = { ...record }

  if (table === PERMISSION_TABLE) {
    const newPermIndex = newRecord.permissions.findIndex(
      (perm) => perm.rolename === name
    )
    const perm = newRecord.permissions[newPermIndex].read

    if (name === 'others') {
      newRecord.permissions[newPermIndex].read = !perm
    } else {
      newRecord.permissions[newPermIndex] = {
        ...newRecord.permissions[newPermIndex],
        ...getPermissionObject(permList, !perm)
      }
    }
  } else {
    // table === FIELDS_TABLE
  }
}

export const deletePermission = async (rolename) => {
  await removePermission(rolename)
  await getPermissions()
}
